export default __webpack_public_path__ + "static/project-details-472f081bedc2d01fe180b3302a297a56.png";